<template>
  <div class="flex flex-col items-center justify-center w-full h-[100vh] bg-white-primary">
    <img
      :src="searchResultEmpty"
      class="h-[160px] w-[160px]"
    />
    <t-space
      direction="vertical"
      class="flex justify-center"
    >
      <p class="text-black-primary opacity-60">Please select a game</p>
    </t-space>
  </div>
</template>

<script setup lang="ts">
import searchResultEmpty from '@/assets/img/empty.png';
</script>
